import { useMutation, useQueryClient } from '@tanstack/react-query';
import { automationStationApi } from '../api';

function updateExpectations({ lobsangEventId, newExpectations }) {
  const url = `v1/automation/${lobsangEventId}/line_segment_expectations`;
  return automationStationApi.put(url, newExpectations);
}

const createUpdatedExpectationsResponse = (newExpectations, cachedAutomationResponse) => {
  // eslint-disable-next-line camelcase
  if (!newExpectations) {
    return cachedAutomationResponse;
  }

  return {
    ...cachedAutomationResponse,
    current_strategy: {
      ...cachedAutomationResponse.current_strategy,
      line_segment_expectations: newExpectations,
    },
    proxy_events: {
      ...cachedAutomationResponse.proxy_events,
    },
  };
};

export function useUpdateExpectations() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: updateExpectations,
    // Optimistic update after mutation
    onSuccess: async (data, { lobsangEventId, newExpectations }) => {
      // Retrieve the current cached response
      const cachedAutomationResponse = queryClient.getQueryData(['automation', lobsangEventId]);
      // If the cached response is not available, skip the update
      if (!cachedAutomationResponse) {
        return;
      }
      const updatedExpectationsResponse = createUpdatedExpectationsResponse(newExpectations, cachedAutomationResponse);

      // Update the cache with the new value
      queryClient.setQueryData(['automation', lobsangEventId], updatedExpectationsResponse);

      // Refetch the data
      queryClient.invalidateQueries({ queryKey: ['automation', lobsangEventId] });
    },
  });
  return mutation;
}
